import { PalletsCell, WeightCell } from 'utils/format';
import { t_stop, someHasChanges, loadHasChanges, fieldHasChanges } from './constants';

const PalletWithUnit = ({ numberOfItems, palletType, itemWidth, itemLength, loadTypes, load }) => {
  return (
    <>
      <PalletsCell
        loadTypes={loadTypes}
        realPallets={numberOfItems}
        typePallets={palletType}
        withEquivalents={false}
        load={load}
      />
      <>
        {palletType === 'CUSTOM_PALLET' && (
          <>
            {' '}
            ({itemWidth} × {itemLength})
          </>
        )}
      </>
    </>
  );
};

const LoadChange = ({ load } = {}) => {
  if (!load) {
    return null;
  }

  if (!loadHasChanges(load)) {
    return null;
  }

  const shouldRenderPalletsChange = someHasChanges([
    load.number_of_items,
    load.pallet_type,
    load.item_width,
    load.item_length,
  ]);

  return (
    <div>
      {t_stop.load}:{' '}
      {shouldRenderPalletsChange && (
        <>
          {!!load.number_of_items.before && (
            <>
              <PalletWithUnit
                numberOfItems={load.number_of_items.before}
                palletType={load.pallet_type.before}
                itemWidth={load.item_width.before}
                itemLength={load.item_length.before}
                loadTypes={load.load_type?.before}
                load={load}
              />{' '}
              &#8594;{' '}
            </>
          )}
          <PalletWithUnit
            numberOfItems={load.number_of_items.after}
            palletType={load.pallet_type.after}
            itemWidth={load.item_width.after}
            itemLength={load.item_length.after}
            loadTypes={load.load_type?.after}
          />
        </>
      )}
      {shouldRenderPalletsChange && fieldHasChanges(load.total_weight) && <>, </>}
      {fieldHasChanges(load.total_weight) && (
        <>
          {!!load.total_weight.before && (
            <>
              <WeightCell weight={load.total_weight.before} /> &#8594;{' '}
            </>
          )}
          <WeightCell weight={load.total_weight.after} />
        </>
      )}
    </div>
  );
};

export default LoadChange;
